import { apiSlice } from "./http";
import { Tags } from "../enum/tags";
import {
  IGetPropagationCampaignsParams,
  IPropagationDetailsResponse,
  IGetPropagationDetailsParams,
  IRetryAllFailedPayload,
  ISimulatePropagationPayload,
  RawPropagationResponse,
} from "src/@types/campaign-propagation";

export const campaignPropagationService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Level 1: Lista campanhas com status agregado
    getPropagationCampaigns: builder.query<
      RawPropagationResponse,
      IGetPropagationCampaignsParams
    >({
      query: (filters) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );

        return {
          url: `/campaigns/propagation?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.CAMPAIGNS, Tags.PROPAGATION],
    }),

    // Level 2: Detalhes de propagação por loja
    getPropagationDetails: builder.query<
      IPropagationDetailsResponse,
      IGetPropagationDetailsParams
    >({
      query: ({ type, code, ...filters }) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );

        return {
          url: `/campaigns/propagation/${type}/${code}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: (_result, _error, { type, code }) => [
        { type: Tags.PROPAGATION, id: `${type}-${code}` },
      ],
    }),

    // Reprocessar loja específica
    retryFailedStore: builder.mutation<{ message: string }, number>({
      query: (storeRecordId) => ({
        url: `/campaigns/propagation/retry/${storeRecordId}`,
        method: "POST",
      }),
      invalidatesTags: [Tags.PROPAGATION],
    }),

    // Reprocessar todas as lojas com falha
    retryAllFailed: builder.mutation<
      { message: string; retriedCount: number },
      IRetryAllFailedPayload
    >({
      query: ({ type, code }) => ({
        url: `/campaigns/propagation/${type}/${code}/retry-all`,
        method: "POST",
      }),
      invalidatesTags: [Tags.PROPAGATION],
    }),

    // Simular propagação (DEV/HML)
    simulatePropagation: builder.mutation<
      { message: string; data: { successCount: number; failedCount: number } },
      ISimulatePropagationPayload
    >({
      query: ({ type, code }) => ({
        url: `/campaigns/propagation/${type}/${code}/simulate`,
        method: "POST",
      }),
      invalidatesTags: [Tags.PROPAGATION],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPropagationCampaignsQuery,
  useGetPropagationDetailsQuery,
  useRetryFailedStoreMutation,
  useRetryAllFailedMutation,
  useSimulatePropagationMutation,
} = campaignPropagationService;
